/* ============================================================
   P0改善用カスタムJS（2026-07-14）
   1) 色選択リストの折りたたみ / 展開（キーボード対応）
   2) 選択中の色名表示
   3) 追従カートバー（メインのカートフォームへ委譲）
   4) 「同じ商品を2点追加」「色違いを選ぶ」
   Dawn標準の variant-radios / product-form の処理には手を入れない。
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var section = document.querySelector('section[id^="MainProduct-"]');
    if (!section) return;

    var variantContainer = section.querySelector('variant-radios') || section.querySelector('variant-selects');
    var colorFieldset = section.querySelector('.color-variation-wrap');
    var colorGrid = section.querySelector('[data-ck-color-grid]');
    var colorToggle = section.querySelector('[data-ck-color-toggle]');
    var selectedColorEl = section.querySelector('[data-ck-selected-color]');
    var mainSubmit = section.querySelector('.product-form__submit');
    var qtyInput = section.querySelector('input.quantity__input[name="quantity"]');

    /* ---- バリエーションJSONの取得 ---- */
    var variants = [];
    try {
      var jsonScript = variantContainer && variantContainer.querySelector('script[type="application/json"]');
      if (jsonScript) variants = JSON.parse(jsonScript.textContent);
    } catch (e) {
      variants = [];
    }

    function getSelectedOptions() {
      var options = [];
      if (!variantContainer) return options;
      variantContainer.querySelectorAll('fieldset').forEach(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        options.push(checked ? checked.value : null);
      });
      return options;
    }

    function getSelectedVariant() {
      var options = getSelectedOptions();
      if (!options.length || !variants.length) return null;
      return (
        variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === options[i];
          });
        }) || null
      );
    }

    function formatMoney(cents) {
      // JPY: Shopifyの金額は最小単位×100で返る（998円 → 99800）
      return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
    }

    /* ---- 1) 色リストの折りたたみ ---- */
    function expandColors() {
      if (!colorFieldset || !colorToggle) return;
      colorFieldset.classList.remove('ck-color-collapsed');
      colorToggle.setAttribute('aria-expanded', 'true');
      colorToggle.textContent = '色を折りたたむ';
    }

    function collapseColors() {
      if (!colorFieldset || !colorToggle) return;
      colorFieldset.classList.add('ck-color-collapsed');
      colorToggle.setAttribute('aria-expanded', 'false');
      colorToggle.textContent = colorToggle.getAttribute('data-label-expand') || 'すべての色を見る';
    }

    if (colorToggle && colorFieldset && colorGrid) {
      colorToggle.setAttribute('data-label-expand', colorToggle.textContent.trim());
      colorToggle.addEventListener('click', function () {
        if (colorFieldset.classList.contains('ck-color-collapsed')) {
          expandColors();
        } else {
          collapseColors();
          colorFieldset.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      // キーボード / スクリーンリーダー: 隠れている色にフォーカスが移ったら自動で展開する
      colorGrid.addEventListener('focusin', function (e) {
        if (!colorFieldset.classList.contains('ck-color-collapsed')) return;
        var label = e.target.id ? colorGrid.querySelector('label[for="' + e.target.id + '"]') : null;
        var el = label || e.target;
        if (el.offsetTop + el.offsetHeight > colorGrid.clientHeight) expandColors();
      });

      // 初期選択色が隠れている場合は最初から展開しておく
      var initialChecked = colorGrid.querySelector('input[type="radio"]:checked');
      if (initialChecked) {
        var initialLabel = colorGrid.querySelector('label[for="' + initialChecked.id + '"]');
        if (initialLabel && initialLabel.offsetTop + initialLabel.offsetHeight > colorGrid.clientHeight) {
          expandColors();
        }
      }
    }

    /* ---- 2) 選択中の色名 + 3) 追従バーの更新 ---- */
    var sticky = document.querySelector('[data-ck-sticky]');
    var stickyImg = sticky && sticky.querySelector('[data-ck-sticky-img]');
    var stickyVariant = sticky && sticky.querySelector('[data-ck-sticky-variant]');
    var stickyPrice = sticky && sticky.querySelector('[data-ck-sticky-price]');
    var stickyAdd = sticky && sticky.querySelector('[data-ck-sticky-add]');
    var stickyAddLabel = sticky && sticky.querySelector('[data-ck-sticky-add-label]');
    var stickyStatus = sticky && sticky.querySelector('[data-ck-sticky-status]');

    function updateSelectedDisplay() {
      var variant = getSelectedVariant();

      if (selectedColorEl && colorFieldset) {
        var checkedColor = colorFieldset.querySelector('input[type="radio"]:checked');
        if (checkedColor) selectedColorEl.textContent = '：' + checkedColor.value;
      }

      if (!sticky) return;

      if (!variant) {
        if (stickyAdd) stickyAdd.disabled = true;
        if (stickyAddLabel) stickyAddLabel.textContent = '在庫なし';
        if (stickyVariant) stickyVariant.textContent = getSelectedOptions().filter(Boolean).join(' / ');
        return;
      }

      if (stickyVariant) stickyVariant.textContent = variant.title;
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyImg && variant.featured_image && variant.featured_image.src) {
        stickyImg.src = variant.featured_image.src;
      }
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (stickyAddLabel) stickyAddLabel.textContent = variant.available ? 'カートに追加' : '売り切れ';
      if (stickyStatus && variant.available) {
        stickyStatus.hidden = true;
        stickyStatus.textContent = '';
      }
    }

    if (variantContainer) {
      variantContainer.addEventListener('change', function () {
        // Dawn本体のバリエーション切替処理の後に実行する
        setTimeout(updateSelectedDisplay, 0);
      });
    }
    updateSelectedDisplay();

    /* ---- 3) 追従バーの表示制御 ----
       メインの購入ボタンが画面内にある間は隠し、画面外に出たら表示する。
       IntersectionObserverはブラウザ側のスロットリングで発火しない場合が
       あるため、passiveなscroll/resizeハンドラで判定する。 */
    if (sticky && mainSubmit) {
      var buttonsArea = section.querySelector('.product-form__buttons') || mainSubmit;
      var lastRun = 0;
      var trailing = null;

      var updateStickyVisibility = function () {
        lastRun = Date.now();
        var rect = buttonsArea.getBoundingClientRect();
        var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
        sticky.hidden = !outOfView;
      };

      var requestStickyUpdate = function () {
        var elapsed = Date.now() - lastRun;
        if (elapsed >= 100) {
          updateStickyVisibility();
        } else if (!trailing) {
          trailing = setTimeout(function () {
            trailing = null;
            updateStickyVisibility();
          }, 100 - elapsed);
        }
      };

      window.addEventListener('scroll', requestStickyUpdate, { passive: true });
      window.addEventListener('resize', requestStickyUpdate, { passive: true });
      updateStickyVisibility();
    }

    function showStickyStatus(message) {
      if (!stickyStatus) return;
      stickyStatus.textContent = message;
      stickyStatus.hidden = false;
    }

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var variant = getSelectedVariant();
        if (!variant || !variant.available) {
          showStickyStatus('選択中の色・サイズは売り切れです。他の色をお選びください。');
          expandColors();
          if (colorFieldset) colorFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (mainSubmit && !mainSubmit.disabled) mainSubmit.click();
      });
    }

    /* ---- 4) 2点購入ボタン ---- */
    var addTwoBtn = section.querySelector('[data-ck-add-two]');
    var pickColorBtn = section.querySelector('[data-ck-pick-color]');

    if (addTwoBtn) {
      addTwoBtn.addEventListener('click', function () {
        if (addTwoBtn.disabled) return;
        var variant = getSelectedVariant();
        if (!variant || !variant.available) {
          expandColors();
          if (colorFieldset) colorFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        // 連打による意図しない多重追加を防ぐ
        addTwoBtn.disabled = true;
        if (qtyInput) {
          qtyInput.value = 2;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (mainSubmit && !mainSubmit.disabled) mainSubmit.click();
        // 送信後は数量セレクターを1へ戻す（次回の通常追加が2点にならないように）
        setTimeout(function () {
          if (qtyInput) {
            qtyInput.value = 1;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          addTwoBtn.disabled = false;
        }, 1500);
      });
    }

    if (pickColorBtn) {
      pickColorBtn.addEventListener('click', function () {
        expandColors();
        if (colorFieldset) {
          colorFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var firstUnchecked = colorFieldset.querySelector('input[type="radio"]:not(:checked)');
          if (firstUnchecked) firstUnchecked.focus({ preventScroll: true });
        }
      });
    }
  });
})();
